<template>
  <res-dialog
    :showDialog="showDialog"
    :maxWidth="600"
    :setWidth="600"
    title="Add Document"
    titleClass="resBlue darken-1 white--text"
    iconColor="white"
    saveButtonText="ADD DOCUMENT"
    :saveDisabled="isSaveDisabled"
    cancelButtonText="CANCEL"
    cancelButtonWidth="80"
    :defaultButtonAction="confirm"
    @save="confirm"
    @cancel="cancel" >
    <v-card-text>
      <div class="font-weight-500 text-center pb-4">
        {{ description }}
      </div>
      <div class="file-input pt-5 pb-5">
        <v-file-input
          label="CHOOSE FILE"
          v-model="documentToUpload.file"
          outlined
          dense
          single-line
          show-size
          truncate-length="200"
          prepend-icon="mdi-paperclip"
          accept="*">
          <template v-slot:selection="{ text }">
            <v-chip small label color="primary">
              {{ text }}
            </v-chip>
          </template>
        </v-file-input>
      </div>
    </v-card-text>
  </res-dialog>
</template>

<script>
  import ResDialog from '@/components/base/ResDialog.vue';

  import IsNullOrWhitespaceMixin from '@/mixins/isNullOrWhitespace.js';

  export default {
    name: 'UploadDocumentDialog',
    components: {
      ResDialog
    },
    mixins: [IsNullOrWhitespaceMixin],
    props: {
      showDialog: {
        type: Boolean
      }
    },
    data () {
      return {
        isSaving: false,
        documentToUpload: {
          displayName: null,
          file: null
        }
      }
    },
    methods: {
      cancel() {
        this.isSaving = true;
        this.$emit('cancel');
      },
      confirm() {
        this.isSaving = true;
        this.$emit('save', this.documentToUpload);
      }
    },
    computed: {
      description() {
        return "Select the document you want to attach, then select ADD DOCUMENT.";
      },
      isSaveDisabled() {
        return this.isSaving || this.documentToUpload.file == null;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .file-input {
    border-top: solid 1px var(--v-resGrey-lighten1);
    border-bottom: solid 1px var(--v-resGrey-lighten1);
  }
</style>